import React, { useEffect, useRef } from "react";
 
 /* -------------------------------------------------
     ✍️  WRITING‑PAD  (free‑draw canvas)
  ------------------------------------------------- */
  export default function WritingPad({ onClose }) {
    const canvasRef = useRef(null);
    const isDown = useRef(false);
  
    /* basic mouse / touch handlers */
    useEffect(() => {
      const cvs = canvasRef.current;
      if (!cvs) return;
      const ctx = cvs.getContext("2d");
      ctx.lineWidth = 3;
      ctx.lineCap = "round";
      ctx.strokeStyle = "#333";
  
      const getPos = (e) =>
        e.touches
          ? { x: e.touches[0].clientX - cvs.offsetLeft, y: e.touches[0].clientY - cvs.offsetTop }
          : { x: e.offsetX, y: e.offsetY };
  
      const down = (e) => {
        isDown.current = true;
        const { x, y } = getPos(e);
        ctx.beginPath();
        ctx.moveTo(x, y);
      };
      const move = (e) => {
        if (!isDown.current) return;
        const { x, y } = getPos(e);
        ctx.lineTo(x, y);
        ctx.stroke();
      };
      const up = () => (isDown.current = false);
  
      cvs.addEventListener("mousedown", down);
      cvs.addEventListener("mousemove", move);
      window.addEventListener("mouseup", up);
      cvs.addEventListener("touchstart", down, { passive: false });
      cvs.addEventListener("touchmove", (e) => {
        e.preventDefault();
        move(e);
      });
      window.addEventListener("touchend", up);
  
      return () => {
        cvs.removeEventListener("mousedown", down);
        cvs.removeEventListener("mousemove", move);
        window.removeEventListener("mouseup", up);
        cvs.removeEventListener("touchstart", down);
        cvs.removeEventListener("touchmove", move);
        window.removeEventListener("touchend", up);
      };
    }, []);
  
    const clear = () => {
      const cvs = canvasRef.current;
      cvs && cvs.getContext("2d").clearRect(0, 0, cvs.width, cvs.height);
    };
  
    return (
      <div className="writing-pad-container">
        <canvas
          ref={canvasRef}
          width={250}
          height={200}
          className="writing-pad-canvas"
        />
        <div style={{ marginTop: 6 }}>
          <button className="button1" onClick={clear} style={{ marginRight: 6 }}>
            Clear
          </button>
          <button className="button1" onClick={onClose}>
            Close Pad
          </button>
        </div>
      </div>
    );
  }